













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ImportRecipe extends Vue {
    private created() {
        this.$store.state.mobileSidebarVisible = false;
        this.$store.state.menuVisible = false;
    }
}
